
export const handleUnitselect = (payload,setUnitData,setPayloadData,setUnitSuggest) => {
  
    if (!payload) return;
  
    setUnitData(payload);
    setPayloadData({
      primaryUnitCode:payload?.primaryUnitCode,
      secondaryUnitCode:payload?.secondaryUnitCode,
      conversion:payload?.conversion,
    })
  
    setUnitSuggest((prev) => {
      let updatedStore = [...(prev?.storeUnits || [])];
  
      // combine default + store units for checking
      const allUnits = [
        ...(prev?.defaultUnits || []),
        ...(prev?.storeUnits || []),
      ];
  
      // check primary unit
      const primaryExists = allUnits.some(
        (u) => u.unitCode === payload?.primaryUnitCode
      );
  
      if (!primaryExists) {
        updatedStore.push({
          unitName: payload?.primaryUnitName,
          unitCode: payload?.primaryUnitCode,
        });
      }
  
      // check secondary unit
      if (payload?.secondaryUnitCode) {
        const secondaryExists = allUnits.some(
          (u) => u.unitCode === payload?.secondaryUnitCode
        );
  
        if (!secondaryExists) {
          updatedStore.push({
            unitName: payload?.secondaryUnitName,
            unitCode: payload?.secondaryUnitCode,
          });
        }
      }
  
      return {
        ...prev,
        storeUnits: updatedStore,
      };
    });
  };

export const handleUnitNameSelect=(unitData,settings)=>{
    const allUnits = [
      ...(settings?.defaultUnits || []).map((u) => ({
        unitCode: u.unitCode,
        unitName: u.unitName,
      })),
      ...(settings?.storeUnits || []).map((u) => ({
        unitCode: u.unitCode,
        unitName: u.unitName,
      })),
    ];
  
    const primaryUnitName = allUnits.find(
      (u) => u.unitCode === unitData?.primaryUnitCode
    )?.unitName;
    
    const secondaryUnitName = allUnits.find(
      (u) => u.unitCode === unitData?.secondaryUnitCode
    )?.unitName;
    return {primaryUnitName,secondaryUnitName};
  }